module.exports = __webpack_public_path__ + "GI.png?fea07b92581fae3e7055525aa05f2b49";